"use client";

import React from "react";
import { ArrowRight, Star, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function EpicEntrances() {
  return <section data-section-id="20536" id="the-poseidon-dossier" className="dark bg-background text-foreground relative w-full overflow-hidden py-20 lg:py-32 flex items-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-background/90 z-10" />
        <div className="w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602358/img/talent_swallowing_magician_cover.png)] bg-cover bg-center blur-3xl saturate-50 opacity-20 scale-110" aria-hidden="true" />
      </div>

      <div className="container relative z-20 mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-6 text-center lg:text-left">
            <div className="space-y-2">
              <Badge variant="outline" className="w-fit mx-auto lg:mx-0 border-destructive/50 text-destructive bg-destructive/5 backdrop-blur-md px-4 py-1 text-xs uppercase tracking-widest font-mono">
                CLASSIFIED
              </Badge>
              <h1 className="font-sans text-5xl md:text-7xl lg:text-8xl font-bold leading-tight text-primary uppercase tracking-widest drop-shadow-[0_0_15px_rgba(6,182,212,0.4)]">
                The Poseidon Project
              </h1>
            </div>
            
            <p className="font-mono text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto lg:mx-0">
              A high-stakes techno-thriller where deep-sea secrets meet futuristic warfare. Decrypt the truth beneath the waves before the silent war consumes us all.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center lg:justify-start">
              <Link to="https://www.amazon.com/Poseidon-Project-Tracy-Vetter/dp/1966012039" newTab>
                <Button size="lg" className="h-14 px-8 text-lg hover:shadow-[0_0_30px_rgba(6,182,212,0.5)] transition-all duration-300 hover:scale-105 bg-primary text-primary-foreground uppercase tracking-wider">
                  Initiate Reading <BookOpen className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Link to="/ShortFilmPage">
                <Button variant="outline" size="lg" className="h-14 px-8 text-lg border-primary/20 bg-primary/5 hover:bg-primary/10 backdrop-blur-sm transition-all duration-300 text-primary uppercase tracking-wider">View Short Film<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 h-5 w-5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/EpicEntrances.tsx|sig:bwau5e" data-ast-start="2828" data-ast-end="2867"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex justify-center lg:justify-end perspective-[1200px]">
            <div className="relative group w-[280px] sm:w-[340px] aspect-[2/3] transition-all duration-700 ease-out [transform-style:preserve-3d] [transform:rotateY(-12deg)_rotateX(5deg)] hover:[transform:rotateY(0deg)_rotateX(0deg)_scale(1.05)]">
              
              {}
              <Badge variant="secondary" className="absolute -top-6 -right-6 z-30 px-4 py-2 text-base font-bold animate-[bounce_3s_infinite] border-2 border-background bg-primary text-primary-foreground">
                <Star className="w-4 h-4 mr-1 fill-current" /> TOP SECRET
              </Badge>

              {}
              <div className="absolute inset-0 overflow-hidden border border-primary/20 bg-card">
                <img src="https://spectre.10web.cloud/wp-content/uploads/2026/04/61y6jNr26TL._SY466_.jpg" alt="The Poseidon Project Book Cover" className="w-full h-full object-cover grayscale brightness-75 hover:grayscale-0 hover:brightness-100 transition-all duration-700" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-primary/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] pointer-events-none" />
              </div>

              {}
              <div className="absolute top-1 bottom-1 right-0 w-4 bg-primary/10 rounded-r-none [transform:translateZ(-2px)_translateX(100%)_rotateY(90deg)] origin-left opacity-50" />
              
              {}
              <div className="absolute inset-0 bg-primary/10 blur-3xl -z-10 [transform:translateZ(-50px)]" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}